import { ENUM_LABELS, type ReagentItemStock } from '#shared/types';
import { formatDate, formatNumber, dash } from '#client/lib/format';

interface StockDetail {
  label: string;
  value: string;
  wide?: boolean;
  mono?: boolean;
}

/** The "Stock" card's rows. Notice and note appear only when there is one. */
export function reagentStockDetails(item: ReagentItemStock): StockDetail[] {
  const unit = ENUM_LABELS.stockUnit[item.base_unit];

  return [
    { label: 'On hand', value: `${formatNumber(item.on_hand_base)} ${unit}` },
    { label: 'Received in total', value: `${formatNumber(item.received_base)} ${unit}` },
    {
      label: 'Runs left',
      value: item.runs_available === null ? 'No recipe uses this' : String(item.runs_available),
    },
    {
      label: 'Reorder at',
      value:
        item.reorder_level_base > 0
          ? `${formatNumber(item.reorder_level_base)} ${unit}`
          : 'Not set',
    },
    { label: 'Pack', value: `${item.pack_label} — ${formatNumber(item.pack_size_base)} ${unit}` },
    { label: 'Storage', value: dash(item.storage_location) },
    {
      label: 'Next expiry',
      value: item.next_expiry_at === null ? '—' : formatDate(item.next_expiry_at),
    },
    { label: 'Code', value: item.code, mono: true },
    ...(item.notice ? [{ label: 'Notice', value: item.notice, wide: true }] : []),
    ...(item.note ? [{ label: 'Note', value: item.note, wide: true }] : []),
  ];
}
